import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {};
const qs = {
  modal: 'data-custom-modal',
  wrapper: 'data-custom-modal-wrapper',
  content: 'data-custom-modal-content',
  close: 'data-custom-modal-close',
}
const qsAll = {
  
}

const toggleModal = (toggle = true, content = null, node = null) => {
  dom.content.innerHTML = ''
  if(content) dom.content.innerHTML = content
  if(!content && node) dom.content.appendChild(node)
  dom.modal.classList.toggle('z-[-1]', !toggle)
  dom.modal.classList.toggle('opacity-0', !toggle)
  dom.modal.classList.toggle('z-30', toggle)
  dom.modal.classList.toggle('opacity-100', toggle)
  document.body.classList.toggle('overflow-hidden', toggle)
  if(toggle && dom.content.querySelector('video')) dom.content.querySelector('video').play()
}

export const setupCustomModal = () => {
  cacheDom(dom, qs, qsAll)
  
  window.openCustomModal = (modalContent, modalNode = null) => {
    toggleModal(true, modalContent, modalNode)
  }
  
  dom.close.addEventListener('click', () => {
    toggleModal(false)
  })
  dom.wrapper.addEventListener('click', (e) => {
    e.stopPropagation()
  })
  dom.modal.addEventListener('click', () => {
    toggleModal(false)
  })
}